// src/admin/pages/UseCases.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { Box, Card, CardContent, Typography, Button, Stack, Chip, Snackbar, Alert } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import PageHeader from '../components/PageHeader';
import { fetchUseCases, approveUseCase, rejectUseCase } from '../lib/adminApi';

export default function UseCases() {
  const { currentUser } = useAuth();
  const [pending, setPending] = useState([]);
  const [toast, setToast] = useState(null);

  const reload = useCallback(async () => {
    setPending(await fetchUseCases('pending_review'));
  }, []);
  useEffect(() => { reload(); }, [reload]);

  const onApprove = async (useCase) => {
    await approveUseCase(currentUser, useCase);
    setToast({ severity: 'success', msg: 'Caso pubblicato in home page' });
    await reload();
  };

  const onReject = async (useCase) => {
    await rejectUseCase(currentUser, useCase);
    setToast({ severity: 'info', msg: 'Caso rifiutato' });
    await reload();
  };

  return (
    <>
      <PageHeader title="Archivio Use-Case" subtitle={`${pending.length} in attesa di revisione`} />
      <Stack spacing={2}>
        {pending.length === 0 && <Typography>Nessun caso in attesa di revisione.</Typography>}
        {pending.map((useCase) => (
          <Card key={useCase.id}>
            <CardContent>
              {useCase.sector && <Chip size="small" label={useCase.sector} sx={{ mb: 1 }} />}
              <Typography>{useCase.anonymizedSummary}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}>
                Testo originale: "{useCase.problemText}"
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                {useCase.createdAt?.toDate ? useCase.createdAt.toDate().toLocaleString() : ''}
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                <Button variant="contained" onClick={() => onApprove(useCase)}>Approva</Button>
                <Button variant="outlined" color="error" onClick={() => onReject(useCase)}>Rifiuta</Button>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
      <Snackbar open={!!toast} autoHideDuration={4000} onClose={() => setToast(null)}>
        <Alert severity={toast?.severity} onClose={() => setToast(null)}>{toast?.msg}</Alert>
      </Snackbar>
    </>
  );
}
